import { render, staticRenderFns } from "./Paypal.vue?vue&type=template&id=423c9af0&scoped=true"
import script from "./Paypal.vue?vue&type=script&lang=js"
export * from "./Paypal.vue?vue&type=script&lang=js"
import style0 from "./Paypal.vue?vue&type=style&index=0&id=423c9af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c9af0",
  null
  
)

export default component.exports